import { DropdownStates as a } from "./states.js";
const w = _ref => {
  let {
    event: e,
    isOpen: u,
    wrapperRef: c,
    setDropdownState: f,
    buttonRef: i
  } = _ref;
  var t, s;
  if (!u || !["ArrowDown", "ArrowUp", "Escape"].includes(e.key)) return;
  if (e.key === "Escape") return (t = i.current) == null || t.focus(), f(a.CLOSED);
  const o = (s = c.current) == null ? void 0 : s.querySelectorAll(".ds-multiselect-option:not([disabled])"),
    p = o[0],
    l = o[o.length - 1];
  o.forEach((d, n) => {
    if (o[n] === e.target) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        const r = o[n + 1];
        return r ? r.focus() : p.focus();
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        const r = o[n - 1];
        return r ? r.focus() : l.focus();
      }
    }
  });
};
export { w as optionsNavigation };